var _defineProperty = require("/home/runner/work/recipe/recipe/node_modules/@babel/runtime/helpers/defineProperty.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var lzString = require('lz-string');

var compressParams = function compressParams(_ref) {
  var code = _ref.code,
      themes = _ref.themes,
      widths = _ref.widths,
      theme = _ref.theme;
  var data = JSON.stringify(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, code ? {
    code: code
  } : {}), themes ? {
    themes: themes
  } : {}), widths ? {
    widths: widths
  } : {}), theme ? {
    theme: theme
  } : {}));
  return lzString.compressToEncodedURIComponent(data);
};

var createUrl = function createUrl(_ref2) {
  var baseUrl = _ref2.baseUrl,
      code = _ref2.code,
      themes = _ref2.themes,
      widths = _ref2.widths,
      _ref2$paramType = _ref2.paramType,
      paramType = _ref2$paramType === void 0 ? 'hash' : _ref2$paramType;
  var path = '';

  if (code || themes || widths) {
    var compressedData = compressParams({
      code: code,
      themes: themes,
      widths: widths
    });
    path = "".concat(paramType === 'hash' ? '#' : '', "?code=").concat(compressedData);
  }

  if (baseUrl) {
    var trimmedBaseUrl = baseUrl.replace(/\/$/, '');
    return "".concat(trimmedBaseUrl, "/").concat(path);
  }

  return path;
};

var createPreviewUrl = function createPreviewUrl(_ref3) {
  var baseUrl = _ref3.baseUrl,
      code = _ref3.code,
      theme = _ref3.theme,
      _ref3$paramType = _ref3.paramType,
      paramType = _ref3$paramType === void 0 ? 'hash' : _ref3$paramType;
  var path = '';

  if (code || theme) {
    var compressedData = compressParams({
      code: code,
      theme: theme
    });
    path = "/preview/".concat(paramType === 'hash' ? '#' : '', "?code=").concat(compressedData);
  }

  if (baseUrl) {
    var trimmedBaseUrl = baseUrl.replace(/\/$/, '');
    return "".concat(trimmedBaseUrl).concat(path);
  }

  return path;
};

module.exports = {
  compressParams: compressParams,
  createUrl: createUrl,
  createPreviewUrl: createPreviewUrl
};